import {
  styled,
  Typography as MuiTypography,
  Select as MuiSelect
} from "@mui/material";
import { Sort } from "@mui/icons-material";
import { getThemeSpacing } from "../../../../../functions/util";
import { shipCove } from "../../../../../assets/styles/colors";

const PREFIX = "ActionTableSortStyles";
export const classes = {
  cssSortIcon: `${PREFIX}-cssSortIcon`,
  cssTypography: `${PREFIX}-cssTypography`,
  dropDown: `${PREFIX}-dropDown`
};

export const SortIcon = styled(Sort)(({ theme }) => ({
  [`&.${classes.cssSortIcon}`]: {
    width: theme.typography.pxToRem(getThemeSpacing(theme, 4)),
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

export const Typography = styled(MuiTypography)(({ theme }) => ({
  [`&.${classes.cssTypography}`]: {
    color: shipCove,
    marginRight: theme.typography.pxToRem(15)
  }
}));

export const Select = styled(MuiSelect)(({ theme }) => ({
  [`&.${classes.dropDown}`]: {
    minWidth: theme.typography.pxToRem(125),
    height: theme.typography.pxToRem(22)
  }
}));
